import { SvgIcon, SvgIconProps } from '@mui/material';

export const CommissionLogisticIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='currentColor'>
        <path
          d='M1 5.25l3.748-3.748A1.7 1.7 0 015.955 1h7.09a1.7 1.7 0 011.207.502L18 5.25M2.701 9.5v6.8a1.7 1.7 0 001.7 1.7h10.2a1.7 1.7 0 001.7-1.7V9.5'
          // stroke='#fff'
          strokeWidth={1.33571}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.051 18v-3.4a1.7 1.7 0 00-1.7-1.7h-1.7a1.7 1.7 0 00-1.7 1.7V18M1 5.25h17M18 5.25V7.8a1.7 1.7 0 01-1.7 1.7 2.295 2.295 0 01-1.352-.536.595.595 0 00-.697 0c-.38.32-.854.509-1.351.536a2.295 2.295 0 01-1.351-.536.595.595 0 00-.697 0c-.381.32-.855.509-1.352.536a2.295 2.295 0 01-1.351-.536.595.595 0 00-.697 0c-.381.32-.855.509-1.352.536a2.295 2.295 0 01-1.351-.536.595.595 0 00-.697 0c-.381.32-.855.509-1.352.536A1.7 1.7 0 011 7.8V5.25'
          // stroke='#fff'
          strokeWidth={1.33571}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
